'use client'

import Error from 'app/components/Error'

export default Error
